const mutations = {

  context(state, id){
    state.shopID = id;
  },

  SOCKET_HYDRATE_MARKET_SHOP(state, data){
    let slug = {}
    slug[data._id] = data
    state.shops = {...state.shops, ...slug}
    state.content = data.content
  },

  SOCKET_HYDRATE_MARKET_PRODUCTS(state, data){
    let {shopID, _id, init, products} = data || {}
    state.products[shopID || _id] = init ? products : {...state.products[shopID || _id], ...products}
  },

  SOCKET_HYDRATE_MARKET(state, data){
    for (const key in data) {
      state[key] = data[key];
    }
  },

  openCloseCartDialog(state, isOpening){
    if(!isOpening)state.cartShowInvoice = false
    state.cartDialog = !!isOpening
  },  
  
  cartShowInvoice(state){
    state.cartShowInvoice = true
  },

  emptyCart(state, shopID){
    let slug = {...state.shopCarts}
    delete slug[shopID]
    state.shopCarts = {...slug}
  },

  saveAllCart(state, shopID) {
    let cart = state.shopCarts[shopID] // {1: {...}, 2:{...}}
    let cartSlug = {}
    let tally = 0
    cartSlug[shopID] = Object.keys(cart).reduce((a, cartKey)=>{
      if(!cart[cartKey].saved) tally++
      a[cartKey] = {...cart[cartKey], ...{saved: true}}
      return a;
    },{})
    state.shopCarts = {...state.shopCarts, ...cartSlug}
    if (tally) {
      //TODO: we should do a snackbar message or something here
    }
  },

  addToCart(state, data){
    let {shopID, ...rest} = data
    let cart = state.shopCarts[shopID] || {}
    let keys = Object.keys(cart)
    let nextKey = keys.length ? Math.max(...keys) + 1 : 1
    let slug = {}
    slug[nextKey] = rest
    cart = {...cart, ...slug}
    let cartSlug = {}
    cartSlug[shopID] = cart
    state.shopCarts = {...state.shopCarts, ...cartSlug}
  },

  deleteFromCart(state, data){
    let {idx, shopID} = data
    let cart = {...state.shopCarts[shopID]}
    delete cart[idx]
    let slug = {}
    slug[shopID] = cart
    state.shopCarts = {...state.shopCarts, ...slug}
  },

  cartSaveItem(state, opt){
    let slug = {...state.shopCarts}
    slug[opt.shopID][opt.key].saved = opt.save;
    state.shopCarts = {...slug}
  },

  subscriptionCheckout: (state, data) => {
    state.subscriptionCart = {...data, show: true}
  },
  subscriptionCheckoutCancel: state => {
    state.subscriptionCart = {...state.subscriptionCart, show: false}
  },

  updateQtyInCart(state, data){
    state.shopCarts[data.context][data.idx].vote.qty = data.qty
  },

  invoice(state, data){state.invoice = data},

  closeSnackbar: state => {
    state.snackbar = {
      show: false,
      text: null,
      timeout: 2000,
      icon: null,  
    }
  },
  openSnackbar: (state, opt) => {
    state.snackbar = {
      show: true,
      text: opt.text,
      timeout: opt.timeout || 2000,
      icon: opt.icon
    }
  }
};

export default mutations;